import { render, staticRenderFns } from "./ExpertProfile.vue?vue&type=template&id=2984c098&scoped=true"
import script from "./ExpertProfile.vue?vue&type=script&lang=js"
export * from "./ExpertProfile.vue?vue&type=script&lang=js"
import style0 from "./ExpertProfile.vue?vue&type=style&index=0&id=2984c098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984c098",
  null
  
)

export default component.exports